"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointsProgress = exports.PointsDescription = exports.HeartsFilled = exports.AvailablePoints = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const PointsProgress = exports.PointsProgress = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));
const AvailablePoints = exports.AvailablePoints = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.offer.main
}));
const HeartsFilled = exports.HeartsFilled = (0, _mui.styled)(_icons.RewardsHeartsFilled)(({
  theme
}) => ({
  color: theme.palette.offer.main,
  fontSize: '3rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '4rem'
  }
}));
const PointsDescription = exports.PointsDescription = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textTransform: 'uppercase',
  fontWeight: 'bold',
  color: theme.palette.text.secondary
}));